import { useEffect, useState } from "react";
import Select from "react-select";
import debounce from "lodash.debounce";
import { useDispatch } from "react-redux";

const AsyncSelectInput2 = ({
  register,
  name,
  label,
  labelWidth,
  setValue,
  errors,
  fetchOptions,
  defaultValue,
}) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Function to query data from database after typing 3 letters
  const loadOptions = debounce(async (input) => {
    if (input.length < 1) {
      setOptions(options);
      return; // Query only when 3 or more characters are typed
    }

    setIsLoading(true);
    try {
      const res = await dispatch(fetchOptions(input));

      let newOptions;
      if (res.payload instanceof Array) {
        newOptions = res.payload.map((item) => {
          return { label: item.name, value: item.id };
        });
      } else {
        newOptions = res.payload.map((item) => {
          return { label: item.name, value: item.id };
        });
      }

      setOptions(newOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
    } finally {
      setIsLoading(false);
    }
  }, 500); // Debounce to limit how often the function is called

  const handleInputChange = (input) => {
    setInputValue(input);
    loadOptions(input);
  };

  const handleChange = (selectedOption) => {
    setValue(name, selectedOption ? selectedOption.value : ""); // Set the value in the form
  };

  useEffect(() => {
    if (defaultValue) {
      setOptions([defaultValue]);
      setValue(name, defaultValue.value);
      handleChange(defaultValue);
      handleInputChange(defaultValue.label);
    }
  }, []);

  //Select styles
  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "hsl(var(--color-content))", // Select box background
      borderColor: state.isFocused
        ? "hsl(var(--color-primary))"
        : "hsl(var(--color-bkg-gen))", // Border color of select
      padding: "2px",
      color: "hsl(var(--color-text1))",
    }),
    singleValue: (base) => ({
      ...base,
      color: "hsl(var(--color-text1))", // Tailwind green-500 for selected text
      // fontWeight: "bold", // Make selected text bold
    }),
    input: (base) => ({
      ...base,
      color: "hsl(var(--color-text1))", // Tailwind indigo-600 for typing color
      // fontWeight: "bold",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "hsl(var(--color-bkg-gen))"
        : "hsl(var(--color-bkg))", // Option background color
      color: "hsl(var(--color-text1))", // Option text color
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "hsl(var(--color-content))", // Dropdown background
      borderColor: "hsl(var(--color-bkg-gen))",
      borderRadius: "4px",
      padding: 2,
    }),
  };
  return (
    <div className="w-full flex-1 min-w-56 py-1">
      <div className="flex gap-4 justify-center items-center">
        <label
          htmlFor={name}
          className={
            "block mb-0.5 text-text-1/90 font-medium text-nowrap " + labelWidth
          }
        >
          {label}
        </label>
        <input {...register(name)} type="hidden" />{" "}
        {/* Register the hidden input for form submission */}
        <Select
          options={options}
          isLoading={isLoading}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          onChange={handleChange}
          placeholder="Type to search..."
          isClearable
          isSearchable
          noOptionsMessage={() =>
            inputValue.length < 3
              ? "Type at least 2 characters..."
              : "No options"
          }
          className="w-full bg-content rounded-none text-base focus:border-bkg text-text-1/75 outline-none focus:outline-primary"
          classNamePrefix="select"
          styles={customStyles}
        />
      </div>
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default AsyncSelectInput2;
